//// Application Packages
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

//// Application Slices
import {
    updateFormData,
    updateFormValidity,
    selectForms,
} from '../../reducers/formSlice'

//// Carbon Components
import { Select, SelectItem } from '@carbon/react'

//// Application Components

//// Carbon Icons

//// Static Constants

//////// Component
const CountrySelectorComponent = ({
    digital_name,
    value_key,
    state_value_key,
    county_value_key,
}) => {
    //////// Hooks
    const dispatch = useDispatch()

    //////// State

    //////// Slices
    const formsData = useSelector(selectForms)

    //// Slice Data

    //////// Search Params

    //////// Methods

    // Re-Validate Data Submission
    const revalidation = async (event_name) => {
        try {
            // Update Validation State
            if (digital_name && event_name) {
                dispatch(
                    updateFormValidity({
                        digital_name: digital_name,
                        errors: {
                            [event_name]: false,
                            [event_name + 'ErrMsg']: '',
                        },
                    })
                )
            }
        } catch (error) {
            console.warn('Revalidation Error:', error)
            return null
        }
    }

    // Handle Data Of All Fields (Country Selector)
    const handleData = (e) => {
        if (e?.target?.name && e?.target?.value) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: {
                        [e.target.name]: e.target.value,
                    },
                })
            )
            revalidation(e.target.name)

            // Cleanup "OUT OF STATE" State
            if (
                e?.target?.name?.includes(value_key) &&
                e?.target?.value !== 'US' &&
                state_value_key
            ) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [state_value_key]: 'FRG',
                        },
                    })
                )
            } else {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [state_value_key]: '',
                        },
                    })
                )
            }

            // Cleanup "OUT OF STATE" County
            if (
                e?.target?.name?.includes(value_key) &&
                e?.target?.value !== 'US' &&
                county_value_key
            ) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [county_value_key]: '825',
                        },
                    })
                )
            } else {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [county_value_key]: '',
                        },
                    })
                )
            }
        } else if (e?.target?.name) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: { [e.target.name]: '' },
                })
            )
            revalidation(e.target.name)
        }

        //// Start Watson Assistant Journey

        //// End Watson Assistant Journey
    }

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <Select
                className="required"
                defaultValue={formsData?.[digital_name]?.values?.[value_key]}
                value={formsData?.[digital_name]?.values?.[value_key]}
                helper=""
                labelText="Country:"
                id={value_key}
                name={value_key}
                onChange={handleData}
                invalid={formsData?.[digital_name]?.errors?.[value_key]}
                invalidText={
                    formsData?.[digital_name]?.errors?.[value_key + 'ErrMsg']
                }
            >
                <SelectItem text="Choose an option" value="" />
                <SelectItem text="United States" value="US" />
                <SelectItem text="Afghanistan" value="AF" />
                <SelectItem text="Albania" value="AL" />
                <SelectItem text="Algeria" value="DZ" />
                <SelectItem text="American Samoa" value="AS" />
                <SelectItem text="Andorra" value="AD" />
                <SelectItem text="Angola" value="AO" />
                <SelectItem text="Anguilla" value="AI" />
                <SelectItem text="Antarctica" value="AQ" />
                <SelectItem text="Antigua & Barbuda" value="AG" />
                <SelectItem text="Argentina" value="AR" />
                <SelectItem text="Armenia" value="AM" />
                <SelectItem text="Aruba" value="AW" />
                <SelectItem text="Australia" value="AU" />
                <SelectItem text="Austria" value="AT" />
                <SelectItem text="Azerbaijan" value="AZ" />
                <SelectItem text="Bahamas" value="BS" />
                <SelectItem text="Bahrain" value="BH" />
                <SelectItem text="Bangladesh" value="BD" />
                <SelectItem text="Barbados" value="BB" />
                <SelectItem text="Belarus" value="BY" />
                <SelectItem text="Belgium" value="BE" />
                <SelectItem text="Belize" value="BZ" />
                <SelectItem text="Benin" value="BJ" />
                <SelectItem text="Bermuda" value="BM" />
                <SelectItem text="Bhutan" value="BT" />
                <SelectItem text="Bolivia" value="BO" />
                <SelectItem value="BA" text="Bosnia & Herzegovina" />
                <SelectItem text="Botswana" value="BW" />
                <SelectItem text="Bouvet Island" value="BV" />
                <SelectItem text="Brazil" value="BR" />
                <SelectItem text="British Indian Ocean" value="IO" />
                <SelectItem text="Brunei Darussalam" value="BN" />
                <SelectItem text="Bulgaria" value="BG" />
                <SelectItem text="Burkina Faso" value="BF" />
                <SelectItem text="Burma" value="?2" />
                <SelectItem text="Burundi" value="BI" />
                <SelectItem text="Cambodia" value="KH" />
                <SelectItem text="Cameroon" value="CM" />
                <SelectItem text="Canada" value="CA" />
                <SelectItem text="Cape Verde" value="CV" />
                <SelectItem text="Cayman Islands" value="KY" />
                <SelectItem text="Central African Rep" value="CF" />
                <SelectItem text="Chad" value="TD" />
                <SelectItem text="Chile" value="CL" />
                <SelectItem text="China" value="CN" />
                <SelectItem text="Christmas Island" value="CX" />
                <SelectItem text="Cocos/Keeling Isl" value="CC" />
                <SelectItem text="Colombia" value="CO" />
                <SelectItem text="Comoros" value="KM" />
                <SelectItem text="Congo" value="CG" />
                <SelectItem text="Congo, Dem Rep" value="CD" />
                <SelectItem text="Cook Islands" value="CK" />
                <SelectItem text="Costa Rica" value="CR" />
                <SelectItem text="Cote Divoire" value="CI" />
                <SelectItem text="Croatia/Hrvatska" value="HR" />
                <SelectItem text="Cuba" value="CU" />
                <SelectItem text="Cyprus" value="CY" />
                <SelectItem text="Czech Republic" value="CZ" />
                <SelectItem text="Denmark" value="DK" />
                <SelectItem text="Djibouti" value="DJ" />
                <SelectItem text="Dominica" value="DM" />
                <SelectItem text="Dominican Republic" value="DO" />
                <SelectItem text="East Timor" value="TP" />
                <SelectItem text="Ecuador" value="EC" />
                <SelectItem text="Egypt" value="EG" />
                <SelectItem text="El Salvador" value="SV" />
                <SelectItem text="Equatorial Guinea" value="GQ" />
                <SelectItem text="Eritrea" value="ER" />
                <SelectItem text="Estonia" value="EE" />
                <SelectItem text="Ethiopia" value="ET" />
                <SelectItem text="Falkland Isl/Malvina" value="FK" />
                <SelectItem text="Faroe Islands" value="FO" />
                <SelectItem text="Fiji" value="FJ" />
                <SelectItem text="Finland" value="FI" />
                <SelectItem text="France" value="FR" />
                <SelectItem text="France, Metropolitan" value="FX" />
                <SelectItem value="GF" text="French Guiana" />
                <SelectItem text="French Polynesia" value="PF" />
                <SelectItem text="French S Territories" value="TF" />
                <SelectItem text="Gabon" value="GA" />
                <SelectItem text="Gambia" value="GM" />
                <SelectItem text="Georgia" value="GE" />
                <SelectItem text="Germany" value="DE" />
                <SelectItem text="Ghana" value="GH" />
                <SelectItem text="Gibraltar" value="GI" />
                <SelectItem text="Greece" value="GR" />
                <SelectItem text="Greenland" value="GL" />
                <SelectItem text="Grenada" value="GD" />
                <SelectItem text="Guadeloupe" value="GP" />
                <SelectItem text="Guam" value="GU" />
                <SelectItem text="Guatemala" value="GT" />
                <SelectItem text="Guinea" value="GN" />
                <SelectItem text="Guinea-Bissau" value="GW" />
                <SelectItem text="Guyana" value="GY" />
                <SelectItem text="Haiti" value="HT" />
                <SelectItem text="Heard & McDonald Isl" value="HM" />
                <SelectItem text="Holy,Vatican City St" value="VA" />
                <SelectItem text="Honduras" value="HN" />
                <SelectItem text="Hong Kong" value="HK" />
                <SelectItem text="Hungary" value="HU" />
                <SelectItem text="Iceland" value="IS" />
                <SelectItem text="India" value="IN" />
                <SelectItem text="Indonesia" value="ID" />
                <SelectItem text="Iran, Islamic Rep of" value="IR" />
                <SelectItem text="Iraq" value="IQ" />
                <SelectItem text="Ireland" value="IE" />
                <SelectItem text="Israel" value="IL" />
                <SelectItem text="Italy" value="IT" />
                <SelectItem text="Jamaica" value="JM" />
                <SelectItem text="Japan" value="JP" />
                <SelectItem text="Jordan" value="JO" />
                <SelectItem text="Kazakhstan" value="KZ" />
                <SelectItem text="Kenya" value="KE" />
                <SelectItem text="Kiribati" value="KI" />
                <SelectItem text="Korea, Peoples Rep" value="KP" />
                <SelectItem text="Korea, Rep of" value="KR" />
                <SelectItem text="Kuwait" value="KW" />
                <SelectItem text="Kyrgyzstan" value="KG" />
                <SelectItem text="Lao Peoples Dem Rep" value="LA" />
                <SelectItem text="Latvia" value="LV" />
                <SelectItem text="Lebanon" value="LB" />
                <SelectItem text="Lesotho" value="LS" />
                <SelectItem text="Liberia" value="LR" />
                <SelectItem text="Libyan Jamahiriya" value="LY" />
                <SelectItem text="Liechtenstein" value="LI" />
                <SelectItem text="Lithuania" value="LT" />
                <SelectItem text="Luxembourg" value="LU" />
                <SelectItem text="Macau" value="MO" />
                <SelectItem text="Macedonia,Yugoslav" value="MK" />
                <SelectItem text="Madagascar" value="MG" />
                <SelectItem text="Malawi" value="MW" />
                <SelectItem text="Malaysia" value="MY" />
                <SelectItem text="Maldives" value="MV" />
                <SelectItem text="Mali" value="ML" />
                <SelectItem text="Malta" value="MT" />
                <SelectItem text="Marshall Islands" value="MH" />
                <SelectItem text="Martinique" value="MQ" />
                <SelectItem text="Mauritania" value="MR" />
                <SelectItem text="Mauritius" value="MU" />
                <SelectItem text="Mayotte" value="YT" />
                <SelectItem text="Mexico" value="MX" />
                <SelectItem text="Micronesia, Fed St" value="FM" />
                <SelectItem text="Moldova, Rep of" value="MD" />
                <SelectItem text="Monaco" value="MC" />
                <SelectItem text="Mongolia" value="MN" />
                <SelectItem text="Montserrat" value="MS" />
                <SelectItem text="Morocco" value="MA" />
                <SelectItem text="Mozambique" value="MZ" />
                <SelectItem text="Myanmar" value="MM" />
                <SelectItem text="Namibia" value="NA" />
                <SelectItem text="Nauru" value="NR" />
                <SelectItem text="Nepal" value="NP" />
                <SelectItem text="Netherlands" value="NL" />
                <SelectItem text="Netherlands Antilles" value="AN" />
                <SelectItem text="New Caledonia" value="NC" />
                <SelectItem text="New Zealand" value="NZ" />
                <SelectItem text="Nicaragua" value="NI" />
                <SelectItem text="Niger" value="NE" />
                <SelectItem text="Nigeria" value="NG" />
                <SelectItem text="Niue" value="NU" />
                <SelectItem text="Norkold Island" value="NF" />
                <SelectItem text="North Korea" value="?4" />
                <SelectItem text="Northern Mariana Isl" value="MP" />
                <SelectItem text="Norway" value="NO" />
                <SelectItem text="Oman" value="OM" />
                <SelectItem text="Pakistan" value="PK" />
                <SelectItem text="Palau" value="PW" />
                <SelectItem text="Panama" value="PA" />
                <SelectItem text="Papua New Guinea" value="PG" />
                <SelectItem text="Paraguay" value="PY" />
                <SelectItem text="Peru" value="PE" />
                <SelectItem text="Philippines" value="PH" />
                <SelectItem text="Pitcairn" value="PN" />
                <SelectItem text="Poland" value="PL" />
                <SelectItem text="Portugal" value="PT" />
                <SelectItem text="Puerto Rico" value="PR" />
                <SelectItem text="Qatar" value="QA" />
                <SelectItem text="Reunion" value="RE" />
                <SelectItem text="Romania" value="RO" />
                <SelectItem text="Russian Federation" value="RU" />
                <SelectItem text="Rwanda" value="RW" />
                <SelectItem text="S Georgia Sandwich" value="GS" />
                <SelectItem text="Saint Helena" value="SH" />
                <SelectItem text="Saint Lucia" value="LC" />
                <SelectItem text="Samoa" value="WS" />
                <SelectItem text="San Marino" value="SM" />
                <SelectItem text="Sao Tome & Principe" value="ST" />
                <SelectItem text="Saudi Arabia" value="SA" />
                <SelectItem text="Senegal" value="SN" />
                <SelectItem text="Serbia & Montenegro" value="?3" />
                <SelectItem text="Seychelles" value="SC" />
                <SelectItem text="Sierra Leone" value="SL" />
                <SelectItem text="Singapore" value="SG" />
                <SelectItem text="Slovakia/Slovak Rep" value="SK" />
                <SelectItem text="Slovenia" value="SI" />
                <SelectItem text="Solomon Islands" value="SB" />
                <SelectItem text="Somalia" value="SO" />
                <SelectItem text="South Africa" value="ZA" />
                <SelectItem text="Spain" value="ES" />
                <SelectItem text="Sri Lanka" value="LK" />
                <SelectItem text="St Kitts & Nevis" value="KN" />
                <SelectItem text="St Pierre & Miquelon" value="PM" />
                <SelectItem text="St Vincent & Grenada" value="VC" />
                <SelectItem text="Sudan" value="SD" />
                <SelectItem text="Suriname" value="SR" />
                <SelectItem text="Svalbard Jan Mayen" value="SJ" />
                <SelectItem text="Swaziland" value="SZ" />
                <SelectItem text="Sweden" value="SE" />
                <SelectItem text="Switzerland" value="CH" />
                <SelectItem text="Syrian Arab Republic" value="SY" />
                <SelectItem text="Taiwan" value="TW" />
                <SelectItem text="Tajikistan" value="TJ" />
                <SelectItem text="Tanzania United Rep" value="TZ" />
                <SelectItem text="Thailand" value="TH" />
                <SelectItem text="Togo" value="TG" />
                <SelectItem text="Tokelau" value="TK" />
                <SelectItem text="Tonga" value="TO" />
                <SelectItem text="Trinidad & Tobago" value="TT" />
                <SelectItem text="Tunisia" value="TN" />
                <SelectItem text="Turkey" value="TR" />
                <SelectItem text="Turkmenistan" value="TM" />
                <SelectItem text="Turks & Caicos Isl" value="TC" />
                <SelectItem text="Tuvalu" value="TV" />
                <SelectItem text="US Minor Outlying Is" value="UM" />
                <SelectItem text="Uganda" value="UG" />
                <SelectItem text="Ukraine" value="UA" />
                <SelectItem text="United Arab Emirates" value="AE" />
                <SelectItem text="United Kingdom" value="GB" />
                <SelectItem text="Uruguay" value="UY" />
                <SelectItem text="Uzbekistan" value="UZ" />
                <SelectItem text="Vanuatu" value="VU" />
                <SelectItem text="Venezuela" value="VE" />
                <SelectItem text="VietNam" value="VN" />
                <SelectItem text="Virgin Isl -British" value="VG" />
                <SelectItem text="Virgin Isl -US" value="VI" />
                <SelectItem text="WEST INDIES" value="WI" />
                <SelectItem text="Wallis & Futuna Isl" value="WF" />
                <SelectItem text="West Bank/Gaza Strip" value="?1" />
                <SelectItem text="Western Sahara" value="EH" />
                <SelectItem text="Yemen" value="YE" />
                <SelectItem text="Yugoslavia" value="YU" />
                <SelectItem text="Zaire" value="ZR" />
                <SelectItem text="Zambia" value="ZM" />
                <SelectItem text="Zimbabwe" value="ZW" />
            </Select>
        </>
    )
}

export default CountrySelectorComponent
